import React from 'react';
import VstComponent from './VstComponent';
import VstHamburger from './VstHamburger';
import classNames from 'classnames';

class VstHeader extends VstComponent {

  constructor() {
    super();
    this._clickLogo = this._clickLogo.bind(this);
  }

  _clickLogo(e) {
    if (this.props.clickLogo) {
      this.props.clickLogo(e);
    }
  }

  render() {
    return (
      <header className={classNames(this.props.className, 'vst-header')} aria-hidden="false">
        <div className="vst-left">
          <div className="vst-logo">
            <a className="vst-link" href="/#/" ref="logo" onClick={this._clickLogo}>
              <img src={this.props.logo} alt={this.props.title} />
            </a>
          </div>
        </div>
        <div className="vst-right">
          <ul className="header-list">
            {this.props.children}
          </ul>
        </div>
        <div className="vst-center">
          {
            this.props.clickHamburger &&
            <VstHamburger active={this.props.activeHamburger}
              clickHamburger={this.props.clickHamburger}
            />
          }
          <span>{this.props.title}</span>
        </div>
      </header>
    );
  }

}

export default VstHeader;
